import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { AutomationComponent } from './automation/automation.component';
import { EquipmentComponent } from './equipment/equipment.component';
import { OemComponent } from './oem/oem.component';
import { ProductsComponent } from './products/products.component';
import { StandardsComponent } from './standards/standards.component';
import { IndustryComponent } from './industry/industry.component';
import { HeaderComponent } from './header/header.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FooterComponent } from './footer/footer.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';




@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutUsComponent,
    AutomationComponent,
    EquipmentComponent,
    OemComponent,
    ProductsComponent,
    StandardsComponent,
    IndustryComponent,
    HeaderComponent,
    FooterComponent,
    ContactUsComponent,
    
   
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
